import { Component,  OnInit } from '@angular/core';
import { SharedDataService } from 'ngx-paf-common';





@Component({
  selector: 'logged-out-azure',
  templateUrl: './logged-out-azure.component.html',
  styleUrls: ['./logged-out-azure.component.scss']
})
export class LoggedOutAzureComponent implements OnInit {

  constructor(public sharedSvc: SharedDataService
  ) { }
  

  ngOnInit(): void {
  }
}
